<template>
  <div class="notice_wrap" >
   <custom-tabs :tab-list="tabList" :value="active" @change="tabsChange" >
     <div class="notice_list" >
       <div class="notice_item" v-for="(item, index) in 10" :key="index" >
         <div class="notice_item_head" >
           <div>
             <div>点评记录</div>
             <div>13:34</div>
           </div>
           <div>新客户 你管我叫啥 于2021-11-12  09:32:34 成为粉丝！欢迎新成员的加入，此处有掌声...</div>
         </div>
         <div class="notice_item_footer" >
           <div>查看详情</div>
           <div class="right" ></div>
         </div>
       </div>
     </div>
   </custom-tabs>
  </div>
</template>
<style scoped lang="less" >
@import "index";
</style>
<script>
export default {
  name: 'notice',
  data() {
    return {
      active: 0,
      tabList: ['活动动态', '系统消息']
    }
  },
  methods: {
    tabsChange(active) {
      this.active = active
    }
  },
  mounted() {

  }
}
</script>
